var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "row" };
var _hoisted_2 = { class: "col" };
var _hoisted_3 = {
    key: 1,
    class: "text"
};
var _hoisted_4 = { class: "col" };
var _hoisted_5 = {
    key: 0,
    class: "line line--aic"
};
var _hoisted_6 = { class: "line__item" };
var _hoisted_7 = { class: "btn__icon" };
var _hoisted_8 = {
    key: 1,
    type: "button",
    class: "btn btn--2 btn--s btn--black win",
    "data-act": "edit_address",
    "data-type": "dynamic"
};
var _hoisted_9 = { class: "btn__icon" };
var _hoisted_10 = ["value"];
var _hoisted_11 = ["value"];
import FormBlock from "../../../../components/form/FormBlock.vue";
import Icon from "../../../../components/Icon.vue";
import DeliveryAddress from "../../../../components/delivery/DeliveryAddress.vue";
import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { DeliveryTypes } from "../../enums";
import { useDeliveryApi } from "../../../../api/deliveryApi";
import FormLocker from "../../../../components/form/FormLocker.vue";
import AddressSelectModal from "../../../addresses/AddressSelectApp.vue";
import EventBus from "../../../../events/EventBus";
import DeliveryMethodsNotice from "./DeliveryMethodsNotice.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryBlock',
    props: /*@__PURE__*/ _mergeModels({
        formData: { type: Object, default: {} },
        sameDayDeliveryAvailable: Boolean,
        sameDay: Boolean,
        orderSum: [Number, String],
        userLoggedIn: Boolean,
    }, {
        "address": {},
        "addressModifiers": {},
        "delivery": {},
        "deliveryModifiers": {},
    }),
    emits: ["update:address", "update:delivery"],
    setup: function (__props) {
        var _a;
        var props = __props;
        var address = _useModel(__props, 'address');
        var modalAddress = ref();
        var delivery = _useModel(__props, 'delivery');
        var addresses = ref([]);
        var available = ref(false);
        var loading = ref(true);
        var locked = computed(function () { var _a; return loading.value || !available.value || !((_a = delivery.value) === null || _a === void 0 ? void 0 : _a.available); });
        var deliveryData = ref();
        var sameDayAvailable = ref(props.sameDayDeliveryAvailable);
        var sameDay = ref(parseInt((_a = props.formData) === null || _a === void 0 ? void 0 : _a.delivery) === DeliveryTypes.SameDay);
        var isSameDay = computed(function () { return sameDayAvailable.value && sameDay.value && address.value.delivery.name === 'courier'; });
        var freeAmount = computed(function () {
            var _a;
            if (!((_a = delivery.value) === null || _a === void 0 ? void 0 : _a.available) || !delivery.value.price || !delivery.value.free || delivery.value.free < props.orderSum) {
                return 0;
            }
            return delivery.value.free - props.orderSum;
        });
        var modal = ref();
        watch(address, function (newAddress, oldAddress) { return updateDelivery((newAddress === null || newAddress === void 0 ? void 0 : newAddress.id) !== (oldAddress === null || oldAddress === void 0 ? void 0 : oldAddress.id) || (newAddress === null || newAddress === void 0 ? void 0 : newAddress.cityFias) !== (oldAddress === null || oldAddress === void 0 ? void 0 : oldAddress.cityFias)); });
        watch(sameDay, function () { return updateDelivery(); });
        onBeforeMount(function () { return updateDelivery(true); });
        function onAddressChange(newAddress, newDelivery) {
            address.value = newAddress;
            deliveryData.value = (newDelivery === null || newDelivery === void 0 ? void 0 : newDelivery.available) ? newDelivery : null;
        }
        function onChangeButtonClick() {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            modal.value.showLoader();
                            _a = addresses;
                            return [4 /*yield*/, useDeliveryApi().getAddressesInfo()];
                        case 1:
                            _a.value = _b.sent();
                            modal.value.show();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function updateDelivery(changed) {
            if (changed === void 0) { changed = false; }
            modalAddress.value = address.value;
            if (changed && address.value) {
                loading.value = true;
                useDeliveryApi().getAddressInfo(address.value.id).then(function (response) {
                    address.value = response.address;
                    deliveryData.value = response.delivery;
                    sameDayAvailable.value = deliveryData.value.sameDay;
                    updateDelivery();
                    loading.value = false;
                });
            }
            if (!address.value || !deliveryData.value) {
                available.value = false;
                delivery.value = undefined;
            }
            else {
                available.value = deliveryData.value.available;
                delivery.value = {
                    id: isSameDay.value ? DeliveryTypes.SameDay : address.value.delivery.id,
                    type: isSameDay.value ? 'sameday' : address.value.delivery.name,
                    available: deliveryData.value.available,
                    price: isSameDay.value ? deliveryData.value.sameDayPrice : deliveryData.value.price,
                    free: isSameDay.value ? 0 : deliveryData.value.free,
                    days: isSameDay.value ? '' : deliveryData.value.days,
                    date: deliveryData.value.date,
                    calendar: deliveryData.value.calendar,
                    cash_disabled: deliveryData.value.cash_disabled,
                };
            }
        }
        function onAddressesModification(modifiedAddress) {
            EventBus.on('modal:close', function (modal) {
                if (modal.id !== 'edit_delivery_address') {
                    return;
                }
                modalAddress.value = modifiedAddress;
                if (address.value) {
                    onChangeButtonClick();
                }
                else {
                    address.value = modifiedAddress;
                }
                EventBus.off('modal:close', this);
            });
        }
        onMounted(function () { return EventBus.on('address:modify', onAddressesModification); });
        onBeforeUnmount(function () { return EventBus.off('address:modify', onAddressesModification); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(FormBlock, { title: "Способ доставки" }, {
                    default: _withCtx(function () {
                        var _a, _b, _c;
                        return [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    (address.value)
                                        ? (_openBlock(), _createBlock(DeliveryAddress, {
                                            key: 0,
                                            address: address.value,
                                            delivery: delivery.value,
                                            available: available.value,
                                            loading: loading.value,
                                            sameDayPrice: (_a = deliveryData.value) === null || _a === void 0 ? void 0 : _a.sameDayPrice,
                                            "same-day-delivery-available": sameDayAvailable.value,
                                            freeAmount: freeAmount.value,
                                            "same-day": sameDay.value,
                                            "onUpdate:sameDay": _cache[0] || (_cache[0] = function ($event) { return ((sameDay).value = $event); })
                                        }, null, 8 /* PROPS */, ["address", "delivery", "available", "loading", "sameDayPrice", "same-day-delivery-available", "freeAmount", "same-day"]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_3, "У вас нет ни одного сохраненного адреса доставки"))
                                ]),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_4, [
                                    (address.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--2 btn--s btn--black",
                                                    "aria-controls": "modal-add-address",
                                                    onClick: _withModifiers(onChangeButtonClick, ["prevent"])
                                                }, [
                                                    _createVNode(FormLocker, {
                                                        message: "Укажите адрес доставки",
                                                        lock: locked.value
                                                    }, null, 8 /* PROPS */, ["lock"]),
                                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                                    _createElementVNode("span", _hoisted_7, [
                                                        _createVNode(Icon, { name: "edit" })
                                                    ]),
                                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "btn__label" }, "Изменить", -1 /* CACHED */))
                                                ])
                                            ]),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createVNode(DeliveryMethodsNotice, { address: address.value }, null, 8 /* PROPS */, ["address"])
                                        ]))
                                        : (_openBlock(), _createElementBlock("button", _hoisted_8, [
                                            _createVNode(FormLocker, {
                                                message: "Укажите адрес доставки",
                                                lock: locked.value
                                            }, null, 8 /* PROPS */, ["lock"]),
                                            _cache[5] || (_cache[5] = _createTextVNode()),
                                            _createElementVNode("span", _hoisted_9, [
                                                _createVNode(Icon, { name: "add" })
                                            ]),
                                            _cache[6] || (_cache[6] = _createTextVNode()),
                                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "btn__label" }, "Добавить", -1 /* CACHED */))
                                        ]))
                                ])
                            ]),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("input", {
                                type: "hidden",
                                name: "delivery",
                                value: (_b = delivery.value) === null || _b === void 0 ? void 0 : _b.id
                            }, null, 8 /* PROPS */, _hoisted_10),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("input", {
                                type: "hidden",
                                name: "address",
                                value: (_c = address.value) === null || _c === void 0 ? void 0 : _c.id
                            }, null, 8 /* PROPS */, _hoisted_11)
                        ];
                    }),
                    _: 1 /* STABLE */
                }),
                _cache[11] || (_cache[11] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createVNode(AddressSelectModal, {
                        addresses: addresses.value,
                        address: modalAddress.value,
                        "no-redirect": "",
                        "user-logged-in": __props.userLoggedIn,
                        onSelect: onAddressChange,
                        ref_key: "modal",
                        ref: modal
                    }, null, 8 /* PROPS */, ["addresses", "address", "user-logged-in"])
                ]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
